import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { ValidationError } from "../api/api";
import type { FlowCard } from "../api/dto/FlowCard";
import { useDisplayLanguage } from "../components/cardFlowEditor/CardContentPreview";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const DeleteCardModal: FC<{
  card: FlowCard;
  deleteCard: (uuid: string) => Promise<void>;
  // When provided, called instead of firing a global refresh() — lets a caller (the flow editor) drop
  // the card from its own local state rather than trigger an app-wide resource refetch.
  onDeleted?: () => void;
}> = (props) => {
  const refresh = useRefresh();
  const [errors, setErrors] = useState<string[]>([]);
  const displayLanguage = useDisplayLanguage();
  const cardName =
    props.card.name[displayLanguage] ?? Object.values(props.card.name)[0] ?? "(naamloos)";

  const confirm = async () => {
    await props.deleteCard(props.card.uuid).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    if (props.onDeleted) {
      props.onDeleted();
    } else {
      refresh();
    }
  };

  return (
    <>
      <div>
        <strong>Let op!</strong> je staat op het punt om de kaart <strong>{cardName}</strong> te
        verwijderen.
      </div>
      {errors.length > 0 && (
        <div className={"text-red-600 text-sm mt-2"}>
          {errors.map((error) => (
            <div key={error}>{error}</div>
          ))}
        </div>
      )}
      <ModalFooter text={"Verwijderen"} icon={faTrash} onSubmit={confirm} />
    </>
  );
};
